module.exports = __webpack_public_path__ + "static/media/icon_group_gray.56b4246b.png";